import { createFileRoute } from "@tanstack/react-router";
import AdminEmailSettings from "@/pages/admin/AdminEmailSettings";

export const Route = createFileRoute("/_adminLayout/admin/email")({
  component: AdminEmailSettings,
});
